module.exports = __webpack_public_path__ + "static/media/replacement_retainers.ec9a8989.png";